import { CarouselApi, cn } from '@wellesley/ui'
import { useState, useEffect, FC } from 'react'

export const useSliderDots = (count?: number) => {
  const [api, setApi] = useState<CarouselApi>()
  const [current, setCurrent] = useState(0)
  const [slides, setSlides] = useState<number>()
  const slidesArray = Array.from(Array(count || slides).keys())

  useEffect(() => {
    if (!api) return

    setSlides(api.slideNodes().length)
    setCurrent(api.selectedScrollSnap() + 1)

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1)
    })
  }, [api])

  const Dots: FC = () => {
    if (slidesArray.length < 2) return null

    return (
      <ul className="flex min-h-5 items-center justify-center">
        {slidesArray?.map((_, index) => (
          <li
            key={index}
            onClick={() => api?.scrollTo(index)}
            className={cn(
              'ml-0.5 size-1.5 cursor-pointer rounded-[10px] bg-gray-300 transition-[0.2s]',
              index + 1 === current && 'w-3 bg-gray-700',
            )}
          />
        ))}
      </ul>
    )
  }

  return [setApi, Dots, api, current] as const
}
